import { EmailSupportLink } from 'containers/EmailSupportLink';
import { TelegramSupportLink } from 'containers/TelegramSupportLink';
import { ContentLayoutComponent } from 'design/contentLayout';
import { MarginComponent } from 'design/margin';
import { PressControlComponent } from 'design/pressControl';
import { TextComponent } from 'design/text/textComponents';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import React from 'react';

type Props = {
  error: Error;
  restore(): void;
};

export const ProdStackManagerFallback = (props: Props) => {
  const { restore } = props;

  const {
    prodStackManager: { fallback: ownDictionary },
  } = useIntlDictionary();

  const dispatch = useAppDispatcher();

  const tryOnceAgain = React.useCallback(() => {
    restore();

    dispatch({
      name: 'ProdStackManager__TryOnceAgain',
    });
  }, [dispatch, restore]);

  return (
    <ContentLayoutComponent
      title={
        <TextComponent size="l" family="futura">
          {ownDictionary.titleText}
        </TextComponent>
      }
      body={
        <>
          {ownDictionary.descriptionText(
            <EmailSupportLink />,
            <TelegramSupportLink />
          )}
          <MarginComponent top={48} />
          <span>
            <PressControlComponent
              type="button"
              theme="primary"
              onPress={tryOnceAgain}
            >
              {ownDictionary.actionText}
            </PressControlComponent>
          </span>
        </>
      }
      backAction={null}
    />
  );
};
